<template>  
    <v-card class="shadow-none app-page-card">
        <v-card-title>
            New revision            
            <v-icon class="btn-close" @click="$store.commit('setCloseRevision',true)">close</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row>                        
                <v-col cols="2">
                    <v-text-field label="Title:" style="margin:2px" v-model="revTitle"></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-text-field label="Key:" style="margin:2px" v-model="revKey"></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-text-field label="Time limit:" style="margin:2px" v-model="timeLimit"></v-text-field>
                </v-col>
                <v-col cols="1">
                    <v-text-field label="Task number:" style="margin:2px" v-model="taskCount"></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-checkbox v-model="startOpen" label="From"></v-checkbox>  
                    <v-row v-if="startOpen">
                        <v-col cols="12">
                            <h3 @click="picker_pos = 1" style="text-align: center; border-style: solid; border-width: thin;">
                                {{my_date_begin}} 
                            </h3>
                            <v-date-picker v-if="picker_pos == 1" @change="picker_pos = -1" no-title v-model='my_date_begin'></v-date-picker> 
                            <h3 @click="picker_pos = 2"  style="text-align: center; border-style: solid; border-width: thin; margin-top: 3px;">
                                {{my_time_begin}} 
                            </h3>
                            <v-time-picker v-if="picker_pos == 2" @change="picker_pos = -1" format="24hr" no-title v-model='my_time_begin'></v-time-picker>                               
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2">
                    <v-checkbox v-model="endOpen" label="To"></v-checkbox>  
                    <v-row v-if="endOpen">
                        <v-col cols="12">
                            <h3 @click="picker_pos = 3" style="text-align: center; border-style: solid; border-width: thin;">
                                {{my_date_end}} 
                            </h3>
                            <v-date-picker v-if="picker_pos == 3" @change="picker_pos = -1" no-title v-model='my_date_end'></v-date-picker> 
                            
                            <h3 @click="picker_pos = 4"  style="text-align: center; border-style: solid; border-width: thin;margin-top: 3px;">
                                {{my_time_end}} 
                            </h3>
                            <v-time-picker v-if="picker_pos == 4" @change="picker_pos = -1" format="24hr" no-title v-model='my_time_end'></v-time-picker>                               
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2">
                    <v-radio-group v-model="rev_type">
                        <v-radio v-for="(el,index) in revstyles" :key="index" :label="el" :value="index" />
                    </v-radio-group>
                </v-col>                        
            </v-row>
            <v-row>
                <v-col cols="12" style="text-align: left;">
                    <p>Click to select/deselect task type: </p>
                    <v-chip v-for="(item,index) in task_types" 
                        :key="index" style="margin:2px"
                        :color="getChipColor(item.selected)" 
                        @click="task_types[index].selected = 1 - task_types[index].selected; taskRecount()">
                    <v-icon>{{item.icon}}</v-icon>
                        {{item.descr}}
                </v-chip>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" style="text-align: left;">
                    <p>Click to select/deselect chapter: </p>
                    <v-chip v-for="(item,index) in chapterList" 
                        :key="index" style="margin:2px"
                        :color="getChipColor(item.selected)" 
                        @click="chapterList[index].selected = 1 - chapterList[index].selected; taskRecount()">
                    {{item.title}}
                </v-chip>
                </v-col>
                <v-col cols="12" style="text-align: center;">
                    Sum of tasks: {{ sum_of_tasks }}
                </v-col>
            </v-row>  
            <v-row>
                <v-col cols="12" >
                    <p>Click to select/deselect chapter: </p>
                    <v-chip v-for="(item,index) in groupList" 
                        :key="index" style="margin:2px"
                        :color="getChipColor(item.selected)" 
                        @click="groupList[index].selected = 1 - groupList[index].selected">
                        {{item.group_name}}
                    </v-chip>
                </v-col>
            </v-row>                   
            <v-row>
                <v-col cols="12" style="text-align: right;margin:2px;" class="course-additional-activities background-transparent shadow-none">
                    <v-btn class="background-transparent" @click="saveRevision()">Save</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

import axios from '../../axios-auth'


export default {
    data() {
        return {
            picker_pos: -1,
            selectedChapters: [],
            showNewRevision: false,
            showGroupIndex: -1,
            sum_of_tasks: 0,
            revstyles: ['random','evenly'],
            rev_id: 0,
            revTitle: '',
            revKey: '',
            timeLimit: 0,
            taskCount: 0,
            startOpen: false,
            endOpen: false,
            my_date_begin: '',
            my_date_end: '',
            my_time_begin: '',
            my_time_end: '',
            rev_type: 0,
            chapterList: [],
            task_types: [],
            groupList: [],
        }
    },
    props:{ prev_id: Number,
            prevTitle: String,
            prevKey: String,
            ptimeLimit: Number,
            ptaskCount: Number,
            pstartOpen: Boolean,
            pendOpen: Boolean,
            pmy_date_begin: String,
            pmy_date_end: String,
            pmy_time_begin: String,
            pmy_time_end: String,
            prev_type: Number,
            pchapterList: Array,
            ptask_types: Array,
            pgroupList: Array,
    }
    ,    
    components: {
        
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.rev_id = this.prev_id
            this.revTitle = this.prevTitle
            this.revKey = this.prevKey
            this.timeLimit = this.ptimeLimit
            this.taskCount = this.ptaskCount
            this.startOpen = this.pstartOpen
            this.endOpen = this.pendOpen
            this.my_date_begin = this.pmy_date_begin
            this.my_date_end = this.pmy_date_end
            this.my_time_begin = this.pmy_time_begin
            this.my_time_end = this.pmy_time_end
            this.rev_type = this.prev_type
            this.chapterList = this.pchapterList
            this.task_types = this.ptask_types
            this.groupList = this.pgroupList

            this.taskRecount()
        },
        saveRevision() {
            const _chl = this.getSelected(this.chapterList,1)
            const _tl = this.getSelected(this.task_types,1)
            const _gr = this.getSelected(this.groupList,1)
            const _nogr = this.getSelected(this.groupList,0)

            if (this.revTitle.length < 1) {
                this.$store.commit('setFeedback', 'Title is missing.')
                return
            }

            if (_chl.length < 1) {
                this.$store.commit('setFeedback', 'Chapters are not selected - select at least one chapter.')
                return
            }
            if (_tl.length < 1) {
                this.$store.commit('setFeedback','Task types are not selected - select at leats one task type.')
                return
            }

            if (this.sum_of_tasks < this.taskCount) {
                this.$store.commit('setFeedback','Selected chapters and task types do not contain enough tasks.')
                return
            }

            if (this.taskCount < 1) {
                this.$store.commit('setFeedback','You have to set at least 1 task.')
                return
            }

            let _data = {
                course_id: this.$route.params.course_id,
                rev_id: this.rev_id,
                rev_title: this.revTitle,
                rev_key: this.revKey,
                time_limit: this.timeLimit,
                task_number: this.taskCount,
                open_begin: this.my_date_begin + ' ' + this.my_time_begin + ":00",
                open_end: this.my_date_end + ' ' + this.my_time_end + ":00",
                check_OB: this.startOpen,
                check_OE: this.endOpen,
                rev_style: this.rev_type,
                question_type_list: _tl,
                chapter_list: _chl,
                group_list: _gr,
                ungroup_list: _nogr
            }

            axios.post('/create-edit-revision', _data, this.$store.getters.getAxiosConfig)
                .then(res => {                    
                    if (res.data.message !='OK') {
                        this.$store.commit('setFeedback', res.message) 
                        return
                    }

                    this.$store.commit('setCloseRevision',true)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })             
        },
        getChipColor(_value) {
            if (_value == 1) return "orange"
            return "silver"
        },
        getSelected(_arr, _value) {
            let _res = ''
            for (const _item of _arr) {
                if (_item.selected == _value) _res = _res + _item.id + ','
            }
            if (_res.length > 0) _res = _res.substring(0,_res.length-1)
            return _res
        },
        taskRecount() {
            let _count = 0
            for(let i = 0; i < this.chapterList.length; i++) {
                if (this.chapterList[i].selected == 1) {
                    for(let j = 0; j < this.task_types.length; j++) {
                        if (this.task_types[j].selected == 1) {
                            _count = _count + parseInt(this.chapterList[i]["T"+this.task_types[j].id])
                        }
                    }
                }
            }
            this.sum_of_tasks = _count
        }
    }
}

</script>
